export enum Timezones {
  AsiaJerusalem = 'Asia/Jerusalem',
  AmericaNewYork = 'America/New_York', //EST
  AmericaLosAngeles = 'America/Los_Angeles', //PST
  EuropeLondon = 'Europe/London',
  AmericaDenver = 'America/Denver',
  UTC = 'UTC',
}
